import React from 'react';
import { Card, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import './Team.css'

const Team = (props) => {
    const { idTeam, strTeam, strTeamBadge, strSport } = props.team;

    return (/*  */
        <div className="team-info text-center row col-sm">
            <Card style={{ width: '18rem' }}>
                <Card.Img style={{ width: '60%', padding: '30px', height: '170px', margin: 'auto' }} variant="top" src={strTeamBadge} />
                <Card.Body>
                    <Card.Title>{strTeam}</Card.Title>
                    <Card.Text>Sport: {strSport}</Card.Text>
                    <Link to={`/team/${idTeam}`}><Button variant="primary">Club Details <FontAwesomeIcon icon={faArrowRight} /></Button></Link>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Team;